export const REGEX_PASSWORD = /^(?=.*[A-Za-z])(?=(.*\d){2})(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
export const PASSWORD_FIELD_ID = "field_p";
